import angular from 'angular';
import loanStatusSelector from './loanStatusSelector';
import './style.scss';

export default angular
  .module('components.loanStatusSelector', [])
  .component('loanStatusSelector', loanStatusSelector).name;
